import { mapActions, mapState } from 'vuex'

export default {
  computed: {
    ...mapState('filtering', ['filters']),

    stateFiltersDisabled: {
      get () {
        return this.filters_disabled
      },

      set (value) {
        this.setFiltersDisabled(value)
      }
    },

    stateSearchTerms: {
      get () {
        return this.filters.search_terms
      },

      set (value) {
        this.setFiltersProperty({ property: 'search_terms', value })
      }
    },

    stateSearchArea: {
      get () {
        return this.filters.search_area
      },
      set (value) {
        this.setFiltersProperty({ property: 'search_area', value })
      }
    },

    stateOpportunityTypes: {
      get () {
        return this.filters.opportunity_types
      },

      set (value) {
        this.setFiltersProperty({ property: 'opportunity_types', value })
      }
    },

    stateTheme: {
      get () {
        return this.filters.theme
      },

      set (value) {
        this.setFiltersProperty({ property: 'theme', value })
      }
    },

    statePosition: {
      get () {
        return this.filters.position
      },

      set (value) {
        this.setFiltersProperty({ property: 'position', value })
      }
    },

    stateAward: {
      get () {
        return this.filters.award
      },

      set (value) {
        this.setFiltersProperty({ property: 'award', value })
      }
    },

    stateHighSchool: {
      get () {
        return this.filters.highSchool
      },

      set (value) {
        this.setFiltersProperty({ property: 'highSchool', value })
      }
    },

    stateCollege: {
      get () {
        return this.filters.college
      },

      set (value) {
        this.setFiltersProperty({ property: 'college', value })
      }
    },

    stateDegreeCompleted: {
      get () {
        return this.filters.degreeCompleted
      },

      set (value) {
        this.setFiltersProperty({ property: 'degreeCompleted', value })
      }
    },

    stateBudgetRange: {
      get () {
        return this.filters.budgetRange
      },

      set (value) {
        this.setFiltersProperty({ property: 'budgetRange', value })
      }
    },

    stateProBowl: {
      get () {
        return this.filters.proBowl
      },

      set (value) {
        this.setFiltersProperty({ property: 'proBowl', value })
      }
    },

    stateCharity: {
      get () {
        return this.filters.charity
      },

      set (value) {
        this.setFiltersProperty({ property: 'charity', value })
      }
    },

    stateSponsor: {
      get () {
        return this.filters.sponsor
      },

      set (value) {
        this.setFiltersProperty({ property: 'sponsor', value })
      }
    },

    stateFirstContract: {
      get () {
        return this.filters.firstContract
      },

      set (value) {
        this.setFiltersProperty({ property: 'firstContract', value })
      }
    },

    stateIndustry: {
      get () {
        return this.filters.industry
      },

      set (value) {
        this.setFiltersProperty({ property: 'industry', value })
      }
    },

    stateInterestCategories: {
      get () {
        return this.filters.interestCategories
      },

      set (value) {
        this.setFiltersProperty({ property: 'interestCategories', value })
      }
    },

    stateSpecialistTopics: {
      get () {
        return this.filters.specialistTopics
      },

      set (value) {
        this.setFiltersProperty({ property: 'specialistTopics', value })
      }
    },

    statePersonalInterests: {
      get () {
        return this.filters.personalInterests
      },

      set (value) {
        this.setFiltersProperty({ property: 'personalInterests', value })
      }
    },

    statePackages: {
      get () {
        return this.filters.packages
      },

      set (value) {
        this.setFiltersProperty({ property: 'packages', value })
      }
    },

    stateSport: {
      get () {
        return this.filters.sport
      },

      set (value) {
        this.setFiltersProperty({ property: 'sport', value })
      }
    },

    stateClub: {
      get () {
        return this.filters.club
      },

      set (value) {
        this.setFiltersProperty({ property: 'club', value })
      }
    },

    stateLeague: {
      get () {
        return this.filters.league
      },

      set (value) {
        this.setFiltersProperty({ property: 'league', value })
      }
    },

    stateCategory: {
      get () {
        return this.filters.category_id
      },

      set (value) {
        this.setFiltersProperty({ property: 'category_id', value })
      }
    },

    stateManager: {
      get () {
        return this.filters.manager
      },

      set (value) {
        this.setFiltersProperty({ property: 'manager', value })
      }
    },

    stateAge: {
      get () {
        return this.filters.age
      },

      set (value) {
        this.setFiltersProperty({ property: 'age', value })
      }
    },

    stateVisibility: {
      get () {
        return this.filters.visibility
      },

      set (value) {
        this.setFiltersProperty({ property: 'visibility', value })
      }
    },

    stateApp: {
      get () {
        return this.filters.app
      },

      set (value) {
        this.setFiltersProperty({ property: 'app', value })
      }
    },

    stateBasedIn: {
      get () {
        return this.filters.based_in
      },

      set (value) {
        if (value.length === 0) {
          this.setFiltersProperty({ property: 'location_region', value: [] })
        }
        this.setFiltersProperty({ property: 'based_in', value })
      }
    },

    stateLocationRegionBasedIn: {
      get () {
        return this.filters.location_region
      },

      set (value) {
        this.setFiltersProperty({ property: 'location_region', value })
      }
    },

    stateAvailableIn: {
      get () {
        return this.filters.available_in
      },

      set (value) {
        this.setFiltersProperty({property: 'available_in', value})
      }
    },

    stateRegion: {
      get () {
        return this.filters.region
      },

      set (value) {
        this.setFiltersProperty({property: 'region', value})
      }
    },

    stateSocialFollowing: {
      get () {
        return this.filters.social_following
      },

      set (value) {
        this.setFiltersProperty({property: 'social_following', value})
      }
    },

    stateClient: {
      get () {
        return this.filters.client
      },
      set (value) {
        this.setFiltersProperty({property: 'client', value})
      }
    },

    stateGender: {
      get () {
        return this.filters.gender
      },

      set (value) {
        this.setFiltersProperty({ property: 'gender', value })
      }
    },

    stateFirstName: {
      get () {
        return this.filters.first_name
      },

      set (value) {
        this.setFiltersProperty({ property: 'first_name', value })
      }
    },

    stateLastName: {
      get () {
        return this.filters.last_name
      },

      set (value) {
        this.setFiltersProperty({ property: 'last_name', value })
      }
    },

    stateCategoryFilter: {
      get () {
        return this.filters.category
      },

      set (value) {
        this.setFiltersProperty({ property: 'category', value })
      }
    },

    stateRetired: {
      get () {
        return this.filters.retired
      },

      set (value) {
        this.setFiltersProperty({ property: 'retired', value })
      }
    },

    stateTalentBudgetCategories: {
      get () {
        return this.filters.talentBudgetCategories
      },

      set (value) {
        this.setFiltersProperty({ property: 'talentBudgetCategories', value })
      }
    },

    stateTalentBudgetCategoryRanges: {
      get () {
        return this.filters.talentBudgetCategoryRanges
      },

      set (value) {
        this.setFiltersProperty({ property: 'talentBudgetCategoryRanges', value })
      }
    }
  },

  methods: {
    ...mapActions('filtering', ['setFiltersProperty'])
  }
}
